import { TenantContext } from '@/components';
import { SortDirection } from '@/components/Table/types';
import { processesRepo } from '@/constants/providers';
import { Process } from '@/modules/Processes/domain';
import { DataWithPagination } from '@/shared/types';
import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { ProcessKey } from './keys';

export const useGetProcessesByCompany = (
  companyId: number,
  pageNumber?: number,
  filter?: string,
  sortBy?: string,
  sortOrder?: SortDirection,
  options?: UseQueryOptions<DataWithPagination<Process[]>>,
) => {
  const { currentSelectedTenant } = useContext(TenantContext);

  return useQuery<DataWithPagination<Process[]>>(
    [
      ...ProcessKey.BY_COMPANY_PAGED(companyId, {
        pageNumber,
        filter,
        sortBy,
        sortOrder,
      }),
      currentSelectedTenant?.id,
    ],
    () =>
      processesRepo.getProcessesByCompany(
        companyId,
        pageNumber,
        filter,
        sortBy,
        sortOrder,
      ),
    options,
  );
};
